import { render, staticRenderFns } from "./WorkflowManagementTeams.vue?vue&type=template&id=0813998e&scoped=true"
import script from "./WorkflowManagementTeams.vue?vue&type=script&lang=js"
export * from "./WorkflowManagementTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813998e",
  null
  
)

export default component.exports